import React, { useEffect, useState } from "react";
import { Tab, Row, Col, Nav } from "react-bootstrap";
import { ClipboardCheck, Person, ShieldCheck } from "react-bootstrap-icons";
import PreauthorizationPayerResponse from "./PreauthorizationPayerResponse";
import PreauthorizationProvideRequest from "./PreauthorizationProvideRequest";
import { useDispatch, useSelector } from "react-redux";
import { ViewPreauthorization, ViewPreauthorizationHistoryLog } from "../config/preauthorizationApi";
import { useParams } from "react-router-dom";
import { getPathFromUrl } from "helpers/utils";
import EliglibilityResposne from "features/eliglibility/eliglibility-check/components/EliglibilityResposne";
import { useLocation } from "react-router-dom";

const PreAuthorizationResponse = ({ row, show, isHistory = false }) => {
  const dispatch = useDispatch();
  const {
    viewPreauthorizationInfo,
  } = useSelector((state) => state.preauthorization);

  const {
    eligibilityData,
    claimResponseData,
    claimCancelResponseData,
    claimRequestData,
  } = useSelector((state) => state.claim);

  const preauthResponse = viewPreauthorizationInfo?.payer_response;
  const preauthRequest = viewPreauthorizationInfo?.provider_request;

  const { id } = useParams();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const claimType = params.get("claim_type");

  // Add activeKey to control the active tab
  const [activeKey, setActiveKey] = useState("mainPayer");

  console.log({ row })

  useEffect(() => {
    if (isHistory) {
      dispatch(ViewPreauthorizationHistoryLog({
        preauthid: id || row?.preauth_fullid,
        claim_type: claimType || row?.claim_type,
        preauth_status: row?.preauthsts,
        created_by: row?.created_by,
        created_at: row?.created_at,
      }))
    } else {
      dispatch(
        ViewPreauthorization({
          preauthid: id || row?.preauth_fullid,
          claim_type: claimType || row?.claim_type,
        })
      );
    }

  }, [dispatch, id, isHistory]);

  // Set the activeKey based on the existence of response data
  useEffect(() => {
    if (
      preauthResponse ||
      claimResponseData?.id ||
      claimCancelResponseData?.id
    ) {
      setActiveKey("mainPayer");
    } else if (claimRequestData?.id || preauthRequest) {
      setActiveKey("provider");
    }
  }, [
    preauthResponse,
    claimResponseData,
    claimRequestData,
    setActiveKey,
    claimCancelResponseData,
  ]);

  return (
    <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
      <Row>
        {/* Sidebar */}
        <Col xs={12} xl={1}>
          <div className="mb-25 mt-lg-8 flex-lg-column">
            <Nav
              variant="pills"
              className="custom-tabs flex-xl-column flex-row"
              fill
              justify
            >
              {/* Payer Response Tab */}
              {(preauthResponse ||
                claimResponseData?.id) && (
                  <Nav.Item>
                    <Nav.Link eventKey="mainPayer">
                      <span className="tab-label">
                        <Person size={24} className="mb-1 text-body-emphasis" />
                        <span className="fs-12 text-nowrap text-body-emphasis">
                          Payer Response
                        </span>
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                )}

              {/* Provider Request Tab */}
              {(preauthRequest || claimRequestData?.id) &&
                !viewPreauthorizationInfo?.preauthadv_id && (
                  <Nav.Item>
                    <Nav.Link eventKey="provider">
                      <span className="tab-label">
                        <ClipboardCheck
                          size={24}
                          className="mb-1 text-body-emphasis"
                        />
                        <span className="fs-12 text-nowrap text-body-emphasis">
                          Provider Request
                        </span>
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                )}

              {/* Eligibility Tab */}
              {(eligibilityData?.id || preauthResponse?.eligbid) && (
                <Nav.Item>
                  <Nav.Link eventKey="member">
                    <span className="tab-label">
                      <ShieldCheck
                        size={24}
                        className="mb-1 text-body-emphasis"
                      />
                      <span className="fs-12 text-nowrap text-body-emphasis">
                        Eligibility
                      </span>
                    </span>
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </div>
        </Col>

        {/* Content */}
        <Col xs={12} xl={11}>
          <Tab.Content className="p-3">
            <Tab.Pane eventKey="mainPayer">
              <PreauthorizationPayerResponse row={row} show={show} />
            </Tab.Pane>
            <Tab.Pane eventKey="provider">
              <PreauthorizationProvideRequest />
            </Tab.Pane>
            <Tab.Pane eventKey="member">
              <EliglibilityResposne />
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default PreAuthorizationResponse;
